import { connect } from 'react-redux'
import { Timescale } from '@opallabs/concepts'
import { selectors } from '@opallabs/wormhole'
import Histogram from '.'

const mapStateToProps = (state, ownProps) => ({
  // Content mode derives the breakdown rows and tooltip totals from this
  // slice, so feed the filtered content — otherwise the breakdown counts
  // content the active filter excludes and disagrees with the grid.
  content: selectors.selectFilteredContent(state),
  currentBrandId: selectors.selectCurrentBrandId(state),
  // Week reads the week the shell saved in Redux. Day is about one day, so
  // it keeps the day the shell asked for: the saved week start would put
  // the mark — and the day the strip snaps to — on the wrong day.
  focusedDay:
    ownProps.mode === Timescale.Day
      ? ownProps.focusedDay
      : selectors.selectWeekViewStartDay(state) || ownProps.focusedDay,
  moments: selectors.selectProxiedMoments(state),
  // The server's timeline endpoint narrows per-post counts by the saved
  // `BrandSetting.filters` (channel/account/label/status), so the bars
  // change shape on filter change even though `totalContentInWeek`
  // (unfiltered) doesn't.
  selectedFilters: selectors.selectSelectedFilters(state),
})

const ConnectedHistogram = connect(mapStateToProps)(Histogram)

export default ConnectedHistogram
